exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("@tencent/docs-design-resources/icon/desktop/svg/tick_white_outline_light_24.svg"));

// Module
exports.push([module.id, ".tips-card-card-disable-31NKy{pointer-events:none;opacity:.5}.tips-card-card-title-2x9ZE{margin-bottom:8px;font-size:16px;font-weight:600;line-height:22px}.tips-card-card-button-2ee4A{margin:4px 8px 4px 0}.tips-card-card-button-2ee4A .tips-card-tick-icon-2V-qK{width:24px;height:24px;background-image:url(" + ___CSS_LOADER_URL___0___ + ")}", ""]);

// Exports
exports.locals = {
	"card-disable": "tips-card-card-disable-31NKy",
	"card-title": "tips-card-card-title-2x9ZE",
	"card-button": "tips-card-card-button-2ee4A",
	"tick-icon": "tips-card-tick-icon-2V-qK"
};